import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://woeexpeqouhtojnuyueg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getLogs = async (site_uuid) => {
  const { data } = await supabase
    .from("site_report")
    .select()
    .eq("site_uuid", site_uuid)
    .order("id", { ascending: false });
  return data;
};

export const setReport = async (payload) => {
  const { data } = await supabase.from("site_report").insert(payload).select();
  return data;
};

export const updateReport = async (id, payload) => {
  const { data } = await supabase
    .from("site_report")
    .update({
      image: payload.image,
    })
    .eq("id", id)
    .select();
  return data;
};
